export const doctorList = {
  uz: {
    choriqulshaymatovName: "Shaymatov Choriqul Ibodullayevich",
    choriqulshaymatovSpec: "Klinika asoschisi va direktori",
    choriqulshaymatovBio:
      "Oliy toifali shifokor, Amerika (ASCRS) va Evropa (ESCRS) katarakta va refraktsion jarrohlar jamiyatlarining a'zosi.",
    choriqulshaymatovUniver1: "Bakalavriat",
    choriqulshaymatovSpec1:
      "Samarqand davlat tibbiyot instituti 1982-1988 yillar",
    choriqulshaymatovUniver2: "Klinik ordinatura",
    choriqulshaymatovSpec2:
      "Toshkent vrachlar malakasini oshirish instituti 1992-1994 yillar",
    choriqulshaymatovUniver3: "",
    choriqulshaymatovSpec3:
      "2003 yilda Moskva shahrida, akademik S.N. Fyodorov nomidagi MNTK «Koʻz mikroxirurgiya » markazida, «Koʻz mikroxirurgiyasining zamonaviy texnologiyalari» mavzusida malaka oshirdi.",
    choriqulshaymatovSpec4:
      "2005 yilda doktor Shaymatov Choriqul Ibodullayevich hozirgi kunda Navoiy viloyatining yetakchi oftalmologiya markazlaridan biri hisoblangan, «CHORIQUL SHAYMATOV GAVHARI» klinikasiga asos soldi.",
    choriqulshaymatovSpec5:
      "2008 yilda Sankt-Peterburg shahrida, akademik S.N. Fyodorov nomidagi MNTK «Koʻz Mikroxirurgiya» markazida, «Glaukomani diagnostika qilish va davolashning zamonaviy usullari» mavzusidagi «WETLAB» kursida malaka oshirdi.",
    choriqulshaymatovSpec6:
      "2011 yilda Hindistondagi xususiy oftalmologiya klinikasida, «Katarakta fakoemulsifikatsiyasi» mavzusidagi «WETLAB» kursida qatnashdi.",
    choriqulshaymatovDegree1: "Katarakta va glaukoma yo‘nalishi jarrohi",
    choriqulshaymatovDegree2: "30 yildan ortiq ish tajribasi",
    choriqulshaymatovAward1:
      "Amerika Katarakta va Refraktsion Jarrohlar Jamiyati (ASCRS) (San-Fransisko, AQSH) 2013 yil",
    choriqulshaymatovAward2:
      "Evropa Katarakta va Refraktsion Jarrohlar Jamiyati (ESCRS) (London, Angliya) 2014 yil",
    choriqulshaymatovAward3:
      "Evropa Katarakta va Refraktsion Jarrohlar Jamiyati (ESCRS) (Vena, Avstriya) 2015 yil",
    choriqulshaymatovAward4:
      "Evropa Katarakta va Refraktsion Jarrohlar Jamiyati (ESCRS) (Lissabon, Portugaliya) 2017 yil",
    choriqulshaymatovAward5:
      "Evropa Katarakta va Refraktsion Jarrohlar Jamiyati (ESCRS) (Parij, Fransiya) 2019 yil",
    choriqulshaymatovAward6:
      "Amerika Katarakta va Refraktsion Jarrohlar Jamiyati (ASCRS) (Vashington, AQSH) 2022 yil",
    choriqulshaymatovAward7:
      "Glaukoma boʻyicha Jahon Kongressi (Rim, Italiya) 2023 yil",
    choriqulshaymatovAward8: "IOC Uzbekistan (Samarqand) 2023 yil",
    mirzaevilyosName: "Mirzaev Ilyosbek Ibodullayevich",
    mirzaevilyosSpec: "Klinika bosh vrachi",
    mirzaevilyosBio:
      "Oliy toifali shifokor, Evropa (ESCRS) katarakta va refraktsion jarrohlar jamiyatining a'zosi.",
    mirzaevilyosUniver1: "Bakalavriat",
    mirzaevilyosSpec1: "Toshkent Davlat Tibbiyot Instituti 1997-2004 yillar",
    mirzaevilyosUniver2: "Klinik ordinatura",
    mirzaevilyosSpec2:
      "Toshkent vrachlar malakasini oshirish instituti 2005-2007 yillar",
    mirzaevilyosUniver3: "",
    mirzaevilyosSpec3: `2007 yildan hozirga qadar "CHORIQUL SHAYMATOV GAVHARI" ko'z klinikasida bosh shifokor lavozimida ishlab kelmoqda.`,
    mirzaevilyosUniver4: "",
    mirzaevilyosSpec4:
      "2015 yilda Toshkent sharidagi Respublika ixtisoslashtirilgan ko'z mikroxirurgiya ilmiy amaliy tibbiyot markazida “lazer jarrohligi” kursida malaka oshirdi.",
    mirzaevilyosUniver5: "",
    mirzaevilyosSpec5: `2019 yilda Ufa shahridagi Ufa Ko'z kasalliklari ilmiy-tadqiqot institutida "Kataraktaning fakoemulsifikatsiyasi" mavzusida "WETLAB" trenajor mashg'ulotlari bilan ilmiy-amaliy tajriba orttirdi.`,
    mirzaevilyosUniver6: "",
    mirzaevilyosSpec6: `2019 yilda Hindistonning Dehli shahridagi "Jain Eye Hospital" xususiy oftalmologiya klinikasida "Kataraktaning fakoemulsifikatsiyasi" dasturi bo'yicha WETLAB trenajerida amaliy mashg'ulotlar mavjud kursni muvaffaqiyatli tamomladi.`,
    mirzaevilyosUniver7: "",
    mirzaevilyosSpec7: `2022 yilda Toshkent shahridagi  Respublika ixtisoslashtirilgan ko'z mikroxirurgiya ilmiy amaliy tibbiyot markazida "Katarakta jarrohligida zamonaviy texnologiyalar" mavzusidagi kursda tahsil oldi.`,
    mirzaevilyosDegree1: "Katarakta va glaukoma yo‘nalishi jarrohi",
    mirzaevilyosDegree2: "19 yildan ortiq ish tajribasi",
    mirzaevilyosAward1:
      "Evropa Katarakta va Refraktsion Jarrohlar Jamiyati (ESCRS) (Milan, Italiya) 2022 yil",
    mirzaevilyosAward2:
      "Glaukoma boʻyicha Jahon Kongressi (Rim, Italiya) 2023 yil",
    mirzaevilyosAward3: "IOC Uzbekistan (Samarqand) 2023 yil",
    mirzaevilyosAward4:
      "Glaukoma boʻyicha Jahon Kongressi (Dublin, Irlandiya) 2024 yil",
    atayevShName: "Atayev Shuxratjon Xasanovich",
    atayevShSpec: "Lazer jarrohi",
    atayevShBio:
      "Oliy toifali shifokor, Evropa (ESCRS) katarakta va refraktsion jarrohlar jamiyatining a'zosi.",
    atayevShDegree1: "Lazer jarrohi",
    atayevShDegree2: "19 yildan ortiq ish tajribasi",
    atayevShUniver1: "Bakalavriat",
    atayevShSpec1: "Toshkent Davlat Tibbiyot Instituti 1997-2004 yillar",
    atayevShUniver2: "Oftalmolog ixtisosligi bo’yich kurs",
    atayevShSpec2: "Samarqand viloyati ko’z kasalliklari shifoxonosi 2006 yil",
    atayevShUniver3: "Klinik ordinatura",
    atayevShSpec3:
      "Toshkent vrachlar malakasini oshirish instituti 2011-2013 yillar",
    atayevShUniver4: "",
    atayevShSpec4:
      "2014-yildan hozirga qadar “Choriqul Shaymatov Gavhari” ko'z klinikasida ishlab kelmoqda.",
    atayevShUniver5: "",
    atayevShSpec5:
      "2022-yilda Toshkent sharidagi Respublika ixtisoslashtirilgan ko'z mikroxirurgiya ilmiy amaliy tibbiyot markazida “lazer jarrohligi” kursida o’qib mutaxassislik oldi",
    atayevShAward1:
      "Evropa Katarakta va Refraktsion Jarrohlar Jamiyati (ESCRS) (Vena, Avstriya) 2023-yil",
    atayevShAward2: "IOC Uzbekistan (Samarqand) 2023-yil",
    ganievShName: "Ganiyev Sherzod Djurakulovich",
    ganievShSpec: "Keratorefraktsion jarroh",
    ganievShBio:
      "Oliy toifali shifokor, Evropa (ESCRS) katarakta va refraktsion jarrohlar jamiyatining a'zosi.",
    ganievShDegree1: "Keratorefraktsion jarroh",
    ganievShDegree2: "16 yildan ortiq ish tajribasi",
    ganievShUniver1: "Bakalavriat",
    ganievShSpec1: "Samarqand davlat tibbiyot instituti 2001-2008 yillar",
    ganievShUniver2: "Klinik ordinatura",
    ganievShSpec2: "Samarqand davlat tibbiyot instituti 2009-2011 yillar",
    ganievShUniver3: "",
    ganievShSpec3:
      "2011 yildan hozirga qadar “Choriqul Shaymatov Gavhari” ko'z klinikasida ishlab kelmoqda",
    ganievShUniver4: "",
    ganievShSpec4:
      "2018 yilda, akademik S.N. Fyodorov nomidagi MNTK «Koʻz Mikroxirurgiya» markazi Volgograd shahri filialida, «Lazer jarrohligi» yo’nalishining LASIK, trans-PRK, femto-LASIK va krosslinking metodlari asosidagi «WETLAB» kursida malaka oshirdi",
    ganievShAward1:
      "XXIX Xalqaro ko‘z shifokorlari kongressi «Oq tunlar» (Sankt-Peterburg, Rossiya) 2023-yil",
    ganievShAward2: "IOC Uzbekistan (Samarqand) 2023-yil",
    ganievShAward3:
      "Evropa Katarakta va Refraktsion Jarrohlar Jamiyati (ESCRS) (Barselona, Ispaniya) 2024-yil",
    oripovOName: "Oripov Oybek Ulug‘bekovich",
    oripovOSpec: "Keratorefraktsion jarroh",
    oripovOBio:
      "2-toifa shifokori, Evropa (ESCRS) katarakta va refraktsion jarrohlar jamiyatining a'zosi.",
    oripovODegree1: "Keratorefraktsion jarroh",
    oripovODegree2: "8 yildan ortiq ish tajribasi",
    oripovOUniver1: "Bakalavriat",
    oripovOSpec1: "Samarqand davlat tibbiyot instituti 2011-2017 yillar",
    oripovOUniver2: "Magistratura",
    oripovOSpec2: "Samarqand davlat tibbiyot instituti 2017-2020 yillar",
    oripovOUniver3: "",
    oripovOSpec3:
      "2020-yildan hozirga qadar “Choriqul Shaymatov Gavhari” ko'z klinikasida ishlab kelmoqda",
    oripovOUniver4: "",
    oripovOSpec4:
      "2018-yilda, akademik S.N. Fyodorov nomidagi MNTK «Koʻz Mikroxirurgiya» markazi Volgograd shahri filialida, «Lazer jarrohligi» yo’nalishining LASIK, trans-PRK, femto-LASIK va krosslinking metodlari asosidagi «WETLAB» kursida malaka oshirdi",
    oripovOUniver5: "",
    oripovOSpec5:
      "2024-yildan, Samarqand davlat tibbiyot instituti, oftalmalogiya kafedirasida erkin izlanuvchi sifatida ilmiy ish bilan shug’ullanmoqda",
    oripovOAward1:
      "Evropa Katarakta va Refraktsion Jarrohlar Jamiyati (ESCRS) (Milan, Italiya) 2022-yil",
    oripovOAward2:
      "Evropa Katarakta va Refraktsion Jarrohlar Jamiyati (ESCRS) (Vena, Avstriya) 2023-yil",
    oripovOAward3: "IOC Uzbekistan (Samarqand) 2023-yil",
    oripovOAward4:
      "Evropa Katarakta va Refraktsion Jarrohlar Jamiyati (ESCRS) (Barselona, Ispaniya) 2024-yil",
    oripovaYName: "Oripova Yoqutxon Choriqulovna",
    oripovaYSpec: "Vrach oftalmolog",
    oripovaYBio: "2-toifa shifokori.",
    oripovaYDegree1: "Vrach oftalmolog",
    oripovaYDegree2: "8 yildan ortiq ish tajribasi",
    oripovaYUniver1: "Bakalavriat",
    oripovaYSpec1: "Samarqand davlat tibbiyot instituti 2011-2017 yillar",
    oripovaYUniver2: "Magistratura",
    oripovaYSpec2: "Samarqand davlat tibbiyot instituti 2017-2020 yillar",
    oripovaYUniver3: "",
    oripovaYSpec3:
      "2020-yildan hozirga qadar “Choriqul Shaymatov Gavhari” ko'z klinikasida ishlab kelmoqda",
    oripovaYUniver4: "",
    oripovaYSpec4:
      "2025 yilda Toshkent sharidagi Respublika ixtisoslashtirilgan ko'z mikroxirurgiya ilmiy amaliy tibbiyot markazida, “Kataraktaning fakoemulsifikatsiyasi” mavzusida “WETLAB” trenajor mashg'ulotlari bilan ilmiy-amaliy tajriba orttirdi",
    oripovaYAward1: "IOC Uzbekistan (Samarqand) 2023-yil",
    eshniyozovZarifName: "Eshniyozov Zarifjon Shuxrat o‘g‘li",
    eshniyozovZarifSpec: "Vrach oftalmolog",
    eshniyozovZarifBio: "2-toifa shifokori.",
    eshniyozovZarifDegree1: "Vrach oftalmolog",
    eshniyozovZarifDegree2: "8 yildan ortiq ish tajribasi",
    eshniyozovZarifUniver1: "Bakalavriat",
    eshniyozovZarifSpec1:
      "Samarqand davlat tibbiyot instituti 2011-2018 yillar",
    eshniyozovZarifUniver2: "Klinik ordinatura",
    eshniyozovZarifSpec2:
      "Samarqand davlat tibbiyot instituti 2018-2020 yillar",
    eshniyozovZarifUniver3: "",
    eshniyozovZarifSpec3:
      "2020-yildan hozirga qadar “Choriqul Shaymatov Gavhari” ko'z klinikasida ishlab kelmoqda.",
    eshniyozovZarifUniver4: "",
    eshniyozovZarifSpec4:
      "2022 yilda Toshkent sharidagi Respublika ixtisoslashtirilgan ko'z mikroxirurgiya ilmiy amaliy tibbiyot markazida, “Oftalmologiyada funksional” tekshirish usullari “WETLAB” mavzusida ilmiy-amaliy tajriba orttirdi",
    eshniyozovZarifAward1:
      "XXIX Xalqaro ko‘z shifokorlari kongressi «Oq tunlar» (Sankt-Peterburg, Rossiya) 2023-yil",
    eshniyozovZarifAward2: "IOC Uzbekistan (Samarqand) 2023-yil",
    xasanovJasurName: "Hasanov Jasur Ikromovich",
    xasanovJasurSpec: "Vrach oftalmolog",
    xasanovJasurBio: "Vrach oftalmolog.",
    xasanovJasurDegree1: "Vrach oftalmolog",
    xasanovJasurDegree2: "3 yildan ortiq ish tajribasi",
    xasanovJasurUniver1: "Bakalavriat",
    xasanovJasurSpec1: "Samarqand davlat tibbiyot instituti 2016-2022 yillar",
    xasanovJasurUniver2: "Klinik ordinatura",
    xasanovJasurSpec2: "Samarqand davlat tibbiyot instituti 2022-2024 yillar",
    xasanovJasurUniver3: "",
    xasanovJasurSpec3:
      "2024-yildan hozirga qadar “Choriqul Shaymatov Gavhari” ko'z klinikasida ishlab kelmoqda",
    xasanovJasurAward1: "IOC Uzbekistan (Samarqand) 2023-yil",
    ibodullayevBektoshName: "Ibodullayev Bektosh Choriqul o‘g‘li",
    ibodullayevBektoshSpec: "Vrach oftalmolog",
    ibodullayevBektoshBio: "Vrach oftalmolog.",
    ibodullayevBektoshDegree1: "Vrach oftalmolog",
    ibodullayevBektoshUniver1: "Bakalavriat",
    ibodullayevBektoshSpec1:
      "Samarqand davlat tibbiyot instituti 2018-2024 yillar",
    ibodullayevBektoshUniver2: "Magistratura",
    ibodullayevBektoshSpec2:
      "Samarqand davlat tibbiyot instituti 2024-yildan",
    ibodullayevBektoshUniver3: "",
    ibodullayevBektoshSpec3:
      "2024-yildan “Choriqul Shaymatov Gavhari” ko'z klinikasida vrach-diagnost bo‘lib ishlaydi.",
    ibodullayevBektoshAward1: "IOC Uzbekistan (Samarqand) 2023-yil",
    ibodullayevBektoshAward2:
      "Evropa Katarakta va Refraktsion Jarrohlar Jamiyati (ESCRS) (Kopengagen, Daniya) 2025-yil",
  },
  ru: {
    choriqulshaymatovName: "Шайматов Чориқул Ибодуллаевич",
    choriqulshaymatovSpec: "Основатель и директор клиники",
    choriqulshaymatovBio:
      "Врач высшей категории, член Американского (ASCRS) и Европейского общества катарактальных и рефракционных хирургов (ESCRS).",
    choriqulshaymatovUniver1: "Бакалавриатура",
    choriqulshaymatovSpec1:
      "Самаркандский Государственный медицинский институт, 1982 - 1988 гг",
    choriqulshaymatovUniver2: "Клиническая ординатура",
    choriqulshaymatovSpec2:
      "Ташкентский институт усовершенствования врачей, 1992 - 1994 гг",
    choriqulshaymatovUniver3: "",
    choriqulshaymatovSpec3:
      "В 2003 году проходил стажировку в Центре МНТК «Микрохирургия глаза» имени академика С.Н. Фёдорова по теме «Современные технологии микрохирургии глаза» в городе Москва.",
    choriqulshaymatovSpec4:
      "В 2005 году доктор Шайматов Чориқул Ибодуллаевич основал клинику «Choriqul Shaymatov Gavhari», которая стала одним из ведущих офтальмологических центров Навоийской области.",
    choriqulshaymatovSpec5:
      "В 2008 году прошел научно-практическое усовершенствование в научно-педагогическом центре МНТК «Микрохирургия глаза» им. академика С.Н. Фёдорова по теме «Современные методы диагностики и лечения глаукомы» с тренажерными занятиями WETLAB в городе Санкт-Петербург.",
    choriqulshaymatovSpec6:
      "В 2011 году прошел обучение в частной офтальмологической клинике Индии по программе «Факоэмульсификация катаракты», включая практику на тренажере WETLAB.",
    choriqulshaymatovDegree1: "Катарактальный хирург и глаукоматолог.",
    choriqulshaymatovDegree2: "Стаж работы более 30 лет",
    choriqulshaymatovAward1:
      "Американское общество катарактальных и рефракционных хирургов (ASCRS) (Сан-Франциско, США) 2013 год.",
    choriqulshaymatovAward2:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Лондон, Англия) 2014 год.",
    choriqulshaymatovAward3:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Вена, Австрия) 2015 год.",
    choriqulshaymatovAward4:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Лиссабон, Португалия) 2017 год.",
    choriqulshaymatovAward5:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Париж, Франция) 2019 год.",
    choriqulshaymatovAward6:
      "Американское общество катарактальных и рефракционных хирургов (ASCRS) (Вашингтон, США) 2022 год.",
    choriqulshaymatovAward7:
      "Всемирный конгресс по глаукоме (Рим, Италия) 2023 год.",
    choriqulshaymatovAward8: "IOC Uzbekistan (Самарканд) 2023 год.",
    mirzaevilyosName: "Мирзаев Илёсбек Ибодуллаевич",
    mirzaevilyosSpec: "Главный врач клиники",
    mirzaevilyosBio:
      "Врач высшей категории, член Европейского общества катарактальных и рефракционных хирургов (ESCRS).",
    mirzaevilyosUniver1: "Бакалавриатура",
    mirzaevilyosSpec1:
      "Ташкентский государственный медицинский институт, 1997 - 2004 гг",
    mirzaevilyosUniver2: "Клиническая ординатура",
    mirzaevilyosSpec2:
      "Ташкентский институт усовершенствования врачей, 2005 - 2007 гг",
    mirzaevilyosUniver3: "",
    mirzaevilyosSpec3:
      "С 2007 года работает в глазной клинике «Choriqul Shaymatov Gavhari» на должности главного врача.",
    mirzaevilyosUniver4: "",
    mirzaevilyosSpec4:
      "В 2015 году прошел специализацию по «лазерной хирургии глаза» в Республиканском специализированном научно-практическом медицинском центре микрохирургии глаза (г. Ташкент).",
    mirzaevilyosUniver5: "",
    mirzaevilyosSpec5:
      "В 2019 году проходил научно-практическое усовершенствование в Уфимском научно-исследовательском институте глазных болезней (г. Уфа) по теме «Факоэмульсификация катаракты», включая тренажерные занятия WETLAB.",
    mirzaevilyosUniver6: "",
    mirzaevilyosSpec6:
      "В 2019 году прошел обучение в частной офтальмологической клинике «Jain Eye Hospital» (г. Дели, Индия) по программе «Факоэмульсификация катаракты», включая практические занятия на тренажере WETLAB.",
    mirzaevilyosUniver7: "",
    mirzaevilyosSpec7:
      "В 2022 году освоил обучение в Республиканском специализированном научно-практическом медицинском центре микрохирургии глаза (г. Ташкент) по программе «Современные технологии в хирургии катаракты».",
    mirzaevilyosDegree1: "Катарактальный хирург и глаукоматолог.",
    mirzaevilyosDegree2: "Стаж работы более 19 лет",
    mirzaevilyosAward1:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Милан, Италия) 2022 год.",
    mirzaevilyosAward2:
      "Всемирный конгресс по глаукоме (Рим, Италия) 2023 год.",
    mirzaevilyosAward3: "IOC Uzbekistan (Самарканд) 2023 год.",
    mirzaevilyosAward4:
      "Всемирный конгресс по глаукоме (Дублин, Ирландия) 2024 год.",
    atayevShName: "Атаев Шухратжон Хасанович",
    atayevShSpec: "Лазерный хирург",
    atayevShBio:
      "Врач высшей категории, член Европейского общества катарактальных и рефракционных хирургов (ESCRS).",
    atayevShDegree1: "Лазерный хирург",
    atayevShDegree2: "Стаж работы более 19 лет",
    atayevShUniver1: "Бакалавриатура",
    atayevShSpec1:
      "Ташкентский государственный медицинский институт, 1997 - 2004 гг",
    atayevShUniver2: "Курс по специализации офтальмолога",
    atayevShSpec2: "Самаркандская областная глазная больница, 2006 г",
    atayevShUniver3: "Клиническая ординатура",
    atayevShSpec3:
      "Ташкентский институт усовершенствования врачей, 2011 - 2013 гг",
    atayevShUniver4: "",
    atayevShSpec4:
      "С 2014 года работает в глазной клинике «Choriqul Shaymatov Gavhari».",
    atayevShUniver5: "",
    atayevShSpec5:
      "В 2022 году прошел специализацию по «лазерной хирургии глаза» в Республиканском специализированном научно-практическом медицинском центре микрохирургии глаза (г. Ташкент).",
    atayevShAward1:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Вена, Австрия) 2023 год.",
    atayevShAward2: "IOC Uzbekistan (Самарканд) 2023 год.",
    ganievShName: "Ганиев Шерзод Джуракулович",
    ganievShSpec: "Кераторефракционный хирург",
    ganievShBio:
      "Врач высшей категории, член Европейского общества катарактальных и рефракционных хирургов (ESCRS).",
    ganievShDegree1: "Кераторефракционный хирург",
    ganievShDegree2: "Стаж работы более 16 лет",
    ganievShUniver1: "Бакалавриатура",
    ganievShSpec1:
      "Самаркандский Государственный медицинский институт, 2001 - 2008 гг",
    ganievShUniver2: "Клиническая ординатура",
    ganievShSpec2:
      "Самаркандский Государственный медицинский институт, 2009 - 2011 гг",
    ganievShUniver3: "",
    ganievShSpec3:
      "С 2011 года работает в глазной клинике «Choriqul Shaymatov Gavhari».",
    ganievShUniver4: "",
    ganievShSpec4:
      "В 2018 году прошёл специализацию по лазерной хирургии глаза в Волгоградском филиале научно-педагогического центра МНТК «Микрохирургия глаза» им. академика С. Н. Фёдорова по методикам ЛАСИК, транс-ФРК, фемто-ЛАСИК и кросслинкинг с тренажерными занятиями WETLAB.",
    ganievShAward1:
      "XXIX Международный офтальмологический конгресс «Белые ночи» (Санкт-Петербург, Россия) 2023 год.",
    ganievShAward2: "IOC Uzbekistan (Самарканд) 2023 год.",
    ganievShAward3:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Барселона, Испания) 2024 год.",
    oripovOName: "Орипов Ойбек Улугбекович",
    oripovOSpec: "Кераторефракционный хирург",
    oripovOBio:
      "Врач второй категории, член Европейского общества катарактальных и рефракционных хирургов (ESCRS).",
    oripovODegree1: "Кераторефракционный хирург",
    oripovODegree2: "Стаж работы более 8 лет",
    oripovOUniver1: "Бакалавриатура",
    oripovOSpec1:
      "Самаркандский Государственный медицинский институт, 2011 - 2017 гг",
    oripovOUniver2: "Магистратура",
    oripovOSpec2:
      "Самаркандский Государственный медицинский институт, 2017 - 2020 гг",
    oripovOUniver3: "",
    oripovOSpec3:
      "С 2020 года работает в глазной клинике «Choriqul Shaymatov Gavhari».",
    oripovOUniver4: "",
    oripovOSpec4:
      "В 2018 году прошёл специализацию по лазерной хирургии глаза в Волгоградском филиале научно-педагогического центра МНТК «Микрохирургия глаза» им. академика С. Н. Фёдорова по методикам ЛАСИК, транс-ФРК, фемто-ЛАСИК и кросслинкинг с тренажерными занятиями WETLAB.",
    oripovOUniver5: "",
    oripovOSpec5:
      "С 2024 года работает в качестве свободного исследователя на кафедре офтальмологии Самаркандского государственного медицинского института, занимаясь научной деятельностью.",
    oripovOAward1:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Милан, Италия) 2022 год.",
    oripovOAward2:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Вена, Австрия) 2023 год.",
    oripovOAward3: "IOC Uzbekistan (Самарканд) 2023 год.",
    oripovOAward4:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Барселона, Испания) 2024 год.",
    oripovaYName: "Орипова Ёқутхон Чориқуловна",
    oripovaYSpec: "Врач офтальмолог",
    oripovaYBio: "Врач второй категории.",
    oripovaYDegree1: "Врач офтальмолог",
    oripovaYDegree2: "Стаж работы более 8 лет",
    oripovaYUniver1: "Бакалавриатура",
    oripovaYSpec1:
      "Самаркандский Государственный медицинский институт, 2011 - 2017 гг",
    oripovaYUniver2: "Магистратура",
    oripovaYSpec2:
      "Самаркандский Государственный медицинский институт, 2017 - 2020 гг",
    oripovaYUniver3: "",
    oripovaYSpec3:
      "С 2020 года работает в глазной клинике «Choriqul Shaymatov Gavhari».",
    oripovaYUniver4: "",
    oripovaYSpec4:
      "В 2025 году проходила научно-практическое усовершенствование в Республиканском специализированном научно-практическом медицинском центре микрохирургии глаза (г. Ташкент) по теме «Факоэмульсификация катаракты», включая тренажерные занятия WETLAB.",
    oripovaYAward1: "IOC Uzbekistan (Самарканд) 2023 год.",
    eshniyozovZarifName: "Эшниёзов Зарифжон Шухрат ўғли",
    eshniyozovZarifSpec: "Врач офтальмолог",
    eshniyozovZarifBio: "Врач второй категории.",
    eshniyozovZarifDegree1: "Врач офтальмолог",
    eshniyozovZarifDegree2: "Стаж работы более 8 лет",
    eshniyozovZarifUniver1: "Бакалавриатура",
    eshniyozovZarifSpec1:
      "Самаркандский Государственный медицинский институт, 2011 - 2018 гг",
    eshniyozovZarifUniver2: "Клиническая ординатура",
    eshniyozovZarifSpec2:
      "Самаркандский Государственный медицинский институт, 2018 - 2020 гг",
    eshniyozovZarifUniver3: "",
    eshniyozovZarifSpec3:
      "С 2020 года работает в глазной клинике «Choriqul Shaymatov Gavhari».",
    eshniyozovZarifUniver4: "",
    eshniyozovZarifSpec4:
      "В 2022 году проходил научно-практическое усовершенствование по теме «Инструментально-функциональное обследование в офтальмологии» в Республиканском специализированном научно-практическом медицинском центре микрохирургии глаза (г. Ташкент).",
    eshniyozovZarifAward1:
      "XXIX Международный офтальмологический конгресс «Белые ночи» (Санкт-Петербург, Россия) 2023 год.",
    eshniyozovZarifAward2: "IOC Uzbekistan (Самарканд) 2023 год.",
    xasanovJasurName: "Ҳасанов Жасур Икромович",
    xasanovJasurSpec: "Врач офтальмолог",
    xasanovJasurBio: "Врач офтальмолог.",
    xasanovJasurDegree1: "Врач офтальмолог",
    xasanovJasurDegree2: "Стаж работы более 3 лет",
    xasanovJasurUniver1: "Бакалавриатура",
    xasanovJasurSpec1:
      "Самаркандский Государственный медицинский институт, 2016 - 2022 гг",
    xasanovJasurUniver2: "Клиническая ординатура",
    xasanovJasurSpec2:
      "Самаркандский Государственный медицинский институт, 2022 - 2024 гг",
    xasanovJasurUniver3: "",
    xasanovJasurSpec3:
      "С 2024 года работает в глазной клинике «Choriqul Shaymatov Gavhari».",
    xasanovJasurAward1: "IOC Uzbekistan (Самарканд) 2023 год.",
    ibodullayevBektoshName: "Ибодуллаев Бектош Чориқул ўғли",
    ibodullayevBektoshSpec: "Врач офтальмолог",
    ibodullayevBektoshBio: "Врач офтальмолог.",
    ibodullayevBektoshDegree1: "Врач офтальмолог",
    ibodullayevBektoshUniver1: "Бакалавриатура",
    ibodullayevBektoshSpec1:
      "Самаркандский Государственный медицинский институт, 2018 - 2024 гг",
    ibodullayevBektoshUniver2: "Магистратура",
    ibodullayevBektoshSpec2:
      "Самаркандский Государственный медицинский институт, с 2024 года",
    ibodullayevBektoshUniver3: "",
    ibodullayevBektoshSpec3:
      "С 2024 года работает врачом-диагностом в глазной клинике «Choriqul Shaymatov Gavhari».",
    ibodullayevBektoshAward1: "IOC Uzbekistan (Самарканд) 2023 год.",
    ibodullayevBektoshAward2:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Копенгаген, Дания) 2025 год.",
  },
  tj: {
    choriqulshaymatovBio:
      "Бо таҷрибаи зиеда аз 15-солаи омӯзиши психология Ва рафтори инсон, доктор Ҷонс мутахассиси табобати ихтилоли рӯҳӣ ва изтироб мебошад",
    choriqulshaymatovUniver1: "Донишгоҳи калифорния, Сан-Франсиско",
    choriqulshaymatovSpec1: "Таълими тиббӣ",
    choriqulshaymatovUniver2: "Маркази тиббии Ucla (UCLA)",
    choriqulshaymatovSpec2: "Аз ординатураи психиатрия гузаштааст",
    choriqulshaymatovUniver3: "Донишгоҳи калифорния Дар Беркли",
    choriqulshaymatovSpec3: "Дараҷаи магистр дар соҳаи тандурустии ҷамъиятӣ",
    choriqulshaymatovSpec4:
      "В 2005 году доктор Шайматов Чориқул Ибодуллаевич основал клинику «Choriqul Shaymatov Gavhari», которая стала одним из ведущих офтальмологических центров Навоийской области.",
    choriqulshaymatovSpec5:
      "В 2008 году прошел научно-практическое усовершенствование в научно-педагогическом центре МНТК «Микрохирургия глаза» им. академика С.Н. Фёдорова по теме «Современные методы диагностики и лечения глаукомы» с тренажерными занятиями WETLAB в городе Санкт-Петербург.",
    choriqulshaymatovSpec6:
      "В 2011 году прошел обучение в частной офтальмологической клинике Индии по программе «Факоэмульсификация катаракты», включая практику на тренажере WETLAB.",
    choriqulshaymatovDegree1:
      "Дар клиникаҳои ҷамъиятии психиатрия, таҷрибаи хусусӣ ва марказҳои тиббии академикӣ кор кардааст",
    choriqulshaymatovDegree2:
      "Таҷриба дар табобати ихтилоли рӯҳӣ, ихтилоли изтироб ва ихтилоли равонӣ",
    choriqulshaymatovDegree3:
      "Таваҷҷӯҳи махсус ба солимии равонии занон ва психиатрияи перинаталӣ",
    choriqulshaymatovDegree4:
      "Таҷрибаи пешбурди корҳои мураккаби марбут ба солимии равонӣ ва мушкилоти тиббӣ",
    choriqulshaymatovAward1: "Узви ассотсиатсияи равоншиносони Амрико (APA)",
    choriqulshaymatovAward2:
      "Барои саҳмгузорӣ дар таҳқиқоти илмӣ бо грантҳои институти Миллии солимии равонӣ (NIMH) ва бунеди амрико оид ба пешгирии худкушӣ қайд карда шудааст.",
    choriqulshaymatovAward3:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Вена, Австрия) 2015 год.",
    choriqulshaymatovAward4:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Лиссабон, Португалия) 2017 год.",
    choriqulshaymatovAward5:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Париж, Франция) 2019 год.",
    choriqulshaymatovAward6:
      "Американское общество катарактальных и рефракционных хирургов (ASCRS) (Вашингтон, США) 2022 год.",
    choriqulshaymatovAward7:
      "Всемирный конгресс по глаукоме (Рим, Италия) 2023 год.",
    choriqulshaymatovAward8: "IOC Uzbekistan (Самарканд) 2023 год.",
    mirzaevilyosBio:
      "Врач высшей категории, член Европейского общества катарактальных и рефракционных хирургов (ESCRS).",
    mirzaevilyosUniver1: "Бакалавриатура",
    mirzaevilyosSpec1:
      "Ташкентский государственный медицинский институт 1997 - 2004 гг",
    mirzaevilyosUniver2: "Клиническая ординатура",
    mirzaevilyosSpec2:
      "Ташкентский институт усовершенствования врачей 2005 - 2007 гг",
    mirzaevilyosUniver3: "",
    mirzaevilyosSpec3:
      "c 2007 года работает в глазной клинике “Choriqul Shaymatov Gavhari” на должности главного врача.",
    mirzaevilyosUniver4: "",
    mirzaevilyosSpec4:
      "в 2015 году прошел специализацию по “лазерной хирургии глаза” в Республиканском специализированном научно-практическом медицинском центре микрохирургии глаза (г. Ташкент).",
    mirzaevilyosUniver5: "",
    mirzaevilyosSpec5:
      "в 2019 году проходил научно-практическое усовершенствование в Уфимском научно-исследовательском институте глазных болезней (г. Уфа) по теме “Факоэмульсификация катаракты”, включая тренажерные занятия WETLAB.",
    mirzaevilyosUniver6: "",
    mirzaevilyosSpec6:
      "в 2019 году прошел обучение в частной офтальмологической клинике «Jain Eye Hospital» (г. Дели, Индия) по программе «Факоэмульсификация катаракты», включая практические занятия на тренажере WETLAB.",
    mirzaevilyosUniver7: "",
    mirzaevilyosSpec7:
      "в 2022 году освоил обучение в Республиканском специализированном научно-практическом медицинском центре микрохирургии глаза (г. Ташкент) по программе «Современные технологии в хирургии катаракты»",
    mirzaevilyosDegree1: "Катарактальный хирург и глаукоматолог.",
    mirzaevilyosDegree2: "Стаж работы более 19 лет",
    mirzaevilyosAward1:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Милан, Италия) 2022 год.",
    mirzaevilyosAward2:
      "Всемирный конгресс по глаукоме (Рим, Италия) 2023 год.",
    mirzaevilyosAward3: "IOC Uzbekistan (Самарканд) 2023 год.",
    mirzaevilyosAward4:
      "Всемирный конгресс по глаукоме (Дублин, Ирландия) 2024 год.",
    atayevShBio:
      "Врач высшей категории, член Европейского общества катарактальных и рефракционных хирургов (ESCRS)",
    atayevShDegree1: "Лазерный хирург",
    atayevShDegree2: "Стаж работы более 19 лет",
    atayevShUniver1: "Бакалавриатура",
    atayevShSpec1:
      "Ташкентский государственный медицинский институт 1997 - 2004 гг",
    atayevShUniver2: "Курс по специализацию офтальмолога",
    atayevShSpec2: "Самаркандская областная глазная больница 2006 г",
    atayevShUniver3: "Клиническая ординатура",
    atayevShSpec3:
      "Ташкентский институт усовершенствования врачей 2011 - 2013 гг",
    atayevShUniver4: "",
    atayevShSpec4:
      "c 2014 года работает в глазной клинике “Choriqul Shaymatov Gavhari”",
    atayevShUniver5: "",
    atayevShSpec5:
      "в 2022 году прошел специализацию по “лазерной хирургии глаза” в Республиканском специализированном научно-практическом медицинском центре микрохирургии глаза (г. Ташкент).",
    atayevShAward1:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Вена, Австрия) 2023 год",
    atayevShAward2: "IOC Uzbekistan (Самарканд) 2023 год",
    ganievShBio:
      "Врач высшей категории, член Европейского общества катарактальных и рефракционных хирургов (ESCRS)",
    ganievShDegree1: "Кераторефракционный хирург",
    ganievShDegree2: "Стаж работы более 16 лет",
    ganievShUniver1: "Бакалавриатура",
    ganievShSpec1:
      "Самаркандский Государственный медицинский институт 2001 - 2008 гг",
    ganievShUniver2: "Клиническая ординатура",
    ganievShSpec2:
      "Самаркандский Государственный медицинский институт 2009 – 2011 гг",
    ganievShUniver3: "",
    ganievShSpec3:
      "c 2011 года работает в глазной клинике “Choriqul Shaymatov Gavhari”",
    ganievShUniver4: "",
    ganievShSpec4:
      "в 2018 году прошёл специализацию по лазерной хирургии глаза в Волгоградском филиале научно-педагогического центра МНТК «Микрохирургия глаза» им. академика С. Н. Фёдорова по методикам ЛАСИК, транс-ФРК, фемто-ЛАСИК и кросслинкинг с тренажерными занятиями «WETLAB»",
    ganievShAward1:
      "XXIX Международный офтальмологический конгресс «Белые ночи» (Санкт-Петербург, Россия) 2023 год",
    ganievShAward2: "IOC Uzbekistan (Самарканд) 2023 год",
    ganievShAward3:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Барселона, Испания) 2024 год",
    oripovOBio:
      "Врач второй категории, член Европейского общества катарактальных и рефракционных хирургов (ESCRS)",
    oripovODegree1: "Кераторефракционный хирург",
    oripovODegree2: "Стаж работы более 8 лет",
    oripovOUniver1: "Бакалавриатура",
    oripovOSpec1:
      "Самаркандский Государственный медицинский институт 2011 - 2017 гг",
    oripovOUniver2: "Магистратура",
    oripovOSpec2:
      "Самаркандский Государственный медицинский институт 2017 – 2020 гг",
    oripovOUniver3: "",
    oripovOSpec3:
      "c 2020 года работает в глазной клинике “Choriqul Shaymatov Gavhari”",
    oripovOUniver4: "",
    oripovOSpec4:
      "в 2018 году прошёл специализацию по лазерной хирургии глаза в Волгоградском филиале научно-педагогического центра МНТК «Микрохирургия глаза» им. академика С. Н. Фёдорова по методикам ЛАСИК, транс-ФРК, фемто-ЛАСИК и кросслинкинг с тренажерными занятиями «WETLAB»",
    oripovOUniver5: "",
    oripovOSpec5:
      "С 2024 года работает в качестве свободного исследователя на кафедре офтальмологии Самаркандского государственного медицинского института, занимаясь научной деятельностью",
    oripovOAward1:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Милан, Италия) 2022 год",
    oripovOAward2:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Вена, Австрия) 2023 год",
    oripovOAward3: "IOC Uzbekistan (Самарканд) 2023 год",
    oripovOAward4:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Барселона, Испания) 2024 год",
    oripovaYBio: "Врач второй категории",
    oripovaYDegree1: "Врач офтальмолог",
    oripovaYDegree2: "Стаж работы более 8 лет",
    oripovaYUniver1: "Бакалавриатура",
    oripovaYSpec1:
      "Самаркандский Государственный медицинский институт 2011 - 2017 гг",
    oripovaYUniver2: "Магистратура",
    oripovaYSpec2:
      "Самаркандский Государственный медицинский институт 2017 – 2020 гг",
    oripovaYUniver3: "",
    oripovaYSpec3:
      "c 2020 года работает в глазной клинике “Choriqul Shaymatov Gavhari”",
    oripovaYUniver4: "",
    oripovaYSpec4:
      "в 2025 году проходил научно-практическое усовершенствование в Республиканском специализированном научно-практическом медицинском центре микрохирургии глаза (г. Ташкент) по теме “Факоэмульсификация катаракты”, включая тренажерные занятия WETLAB",
    oripovaYAward1: "IOC Uzbekistan (Самарканд) 2023 год",
    eshniyozovZarifBio: "Врач второй категории",
    eshniyozovZarifDegree1: "Врач офтальмолог",
    eshniyozovZarifDegree2: "Стаж работы более 8 лет",
    eshniyozovZarifUniver1: "Бакалавриатура",
    eshniyozovZarifSpec1:
      "Самаркандский Государственный медицинский институт 2011 - 2018 гг",
    eshniyozovZarifUniver2: "Клиническая ординатура",
    eshniyozovZarifSpec2:
      "Самаркандский Государственный медицинский институт 2018 – 2020 гг",
    eshniyozovZarifUniver3: "",
    eshniyozovZarifSpec3:
      "c 2020 года работает в глазной клинике “Choriqul Shaymatov Gavhari”",
    eshniyozovZarifUniver4: "",
    eshniyozovZarifSpec4:
      "в 2022 году проходил научно-практическое усовершенствование по теме “Инструментально-функциональное обследование в офтальмологии” в Республиканском специализированном научно-практическом медицинском центре микрохирургии глаза (г. Ташкент)",
    eshniyozovZarifAward1:
      "XXIX Международный офтальмологический конгресс «Белые ночи» (Санкт-Петербург, Россия) 2023 год",
    eshniyozovZarifAward2: "IOC Uzbekistan (Самарканд) 2023 год",
    xasanovJasurBio: "",
    xasanovJasurDegree1: "Врач офтальмолог",
    xasanovJasurDegree2: "Стаж работы более 3 лет",
    xasanovJasurUniver1: "Бакалавриатура",
    xasanovJasurSpec1:
      "Самаркандский Государственный медицинский институт 2016 - 2022 гг",
    xasanovJasurUniver2: "Клиническая ординатура",
    xasanovJasurSpec2:
      "Самаркандский Государственный медицинский институт 2022 – 2024 гг",
    xasanovJasurUniver3: "",
    xasanovJasurSpec3:
      "c 2024 года работает в глазной клинике “Choriqul Shaymatov Gavhari”",
    xasanovJasurAward1: "IOC Uzbekistan (Самарканд) 2023 год",
    ibodullayevBektoshBio: "",
    ibodullayevBektoshDegree1: "Врач офтальмолог",
    ibodullayevBektoshUniver1: "Бакалавриатура",
    ibodullayevBektoshSpec1:
      "Самаркандский Государственный медицинский институт 2018 - 2024 гг",
    ibodullayevBektoshUniver2: "Магистратура",
    ibodullayevBektoshSpec2:
      "Самаркандский Государственный медицинский институт с 2024 года",
    ibodullayevBektoshUniver3: "",
    ibodullayevBektoshSpec3:
      "c 2024 года работает врачом-диагностом в глазной клинике “Choriqul Shaymatov Gavhari”",
    ibodullayevBektoshAward1: "IOC Uzbekistan (Самарканд) 2023 год",
    ibodullayevBektoshAward2:
      "Европейское общество катарактальных и рефракционных хирургов (ESCRS) (Копенгаген, Дания) 2025 год.",
  },
};
